import { render, staticRenderFns } from "./CanalWebSinglePage.vue?vue&type=template&id=72256d31&scoped=true&lang=pug"
import script from "./CanalWebSinglePage.vue?vue&type=script&lang=js"
export * from "./CanalWebSinglePage.vue?vue&type=script&lang=js"
import style0 from "./CanalWebSinglePage.vue?vue&type=style&index=0&id=72256d31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72256d31",
  null
  
)

export default component.exports